import React from "react";
import classNames from "classnames";
import { useMeet } from "util/useMeet";
import { useKnownLiftingOrder } from "util/useKnownLiftingOrder";
import take from "lodash/take";
import { usePlatform } from "util/usePlatform";
import { useCurrentAttempt } from "util/useCurrentAttempt";
import capitalize from "lodash/capitalize";
import DisplayComponent from "./DisplayComponent";
import { WidgetId } from "./DisplaySettingsProvider";

const NextOverlay = ({
  platformId,
  id,
}: {
  platformId: string;
  id: WidgetId;
}) => {
  const meet = useMeet();
  const platform = usePlatform(platformId);
  const lifterOrder = useKnownLiftingOrder(platformId);
  const currentAttempt = useCurrentAttempt(platformId);

  const nextFive = take(
    lifterOrder.filter((a) => a.attemptId !== currentAttempt._id),
    5,
  );

  if (!platform || !meet) {
    return null;
  }

  return (
    <DisplayComponent style={{ top: 900, left: 0 }} id={id}>
      {() => {
        return (
          <div className="next-overlay">
            {nextFive.map((attempt) => {
              const lifterName = attempt.lifter.name || "";
              const liftName = capitalize(attempt.attempt.liftName || "");
              const attemptNumber = attempt.attempt.attemptNumber || "";
              const weight = attempt.attempt.weight || "";

              return (
                <div className="next-overlay-row" key={attempt.attemptId}>
                  <div></div>
                  <div
                    className={classNames("next-overlay-lifter", {
                      "long-name": lifterName.length > 18,
                      "really-long-name": lifterName.length > 21,
                    })}
                  >
                    {lifterName}
                  </div>
                  <div className="next-overlay-lift">
                    {liftName} {attemptNumber}
                  </div>
                  <div className="next-overlay-weight">
                    {weight}
                    {meet.units}
                  </div>
                </div>
              );
            })}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default NextOverlay;
